/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { isEmpty } from '@ember/utils';

import { defaultTinyMCEConfig } from '@linc-technologies/linced-common/utils/tinymce';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';

export default class SuspensionExtensionManager extends Component {
  dialogOpen = false;
  suspension = null;

  @tracked
  editing = false;

  @tracked
  extensionToEdit = null;

  @tracked
  extensionLetters = [];

  @tracked
  reason = '';

  @action
  setReason(value) {
    this.reason = value;
  }

  extensionReasonConfig = Object.freeze(
    Object.assign(
      {
        placeholder:
          'Add any details (for internal use only) as to why this extension was necessary',
        height: 200,
      },
      defaultTinyMCEConfig(),
    ),
  );

  // Overridable no-op defaults supplied by the caller as component arguments.
  // These must stay plain (undecorated) so they remain writable at create time.
  closeDialog() {}
  addExtension() {}
  viewDocuments() {}

  @action
  handleCloseDialog() {
    this.closeDialog();
  }

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);

    const suspension = this.suspension;

    if (!isEmpty(suspension)) {
      this.extensionLetters = suspension.get('extensionLetters');
    }
  }

  @action
  handleAddExtension() {
    this.addExtension(this.suspension);
  }

  @action
  cancel() {
    this.editing = false;
    this.extensionToEdit = null;
    this.reason = '';
  }

  @action
  editExtension(extension) {
    this.editing = true;
    this.extensionToEdit = extension;
    this.reason = extension.reason;
  }

  @action
  save() {
    const extension = this.extensionToEdit;
    extension.set('reason', this.reason);
    this.suspension.save().then(() => {
      this.cancel();
    });
  }

  @action
  handleViewDocuments(extension) {
    // resolve the async PromiseManyArray upfront.
    const letters = resolved(this.extensionLetters);
    this.viewDocuments(
      letters.filter((letter) => extension.letterIds.includes(letter.id)),
    );
  }
}
